import React from 'react';
import PropTypes from 'prop-types';
import { renderReleaseDate } from '../../../util-lib/discount-headline';
import './style.scss';

const Author = ({ avatar, name, publishTime }) => {
  return (
    <article className="author">
      <section className="avatar" style={{ backgroundImage: `url(${avatar})` }} />
      <section className="info">
        <p>{name}</p>
        <time>{renderReleaseDate(publishTime)}</time>
      </section>
    </article>
  );
};

Author.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  publishTime: PropTypes.number
};

export default Author;
